import { useEffect, useState } from 'react';

import { NumberUnitInput } from '../NumberUnitInput';

import type { TypeInputStatus } from '~/types/common.types';

import styles from './TableCellRenderer.module.scss';

export type TypeNumberInputCellParams = {
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  status?: TypeInputStatus;
  validationMessage?: string;
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
  onFocus?: () => void;
};

export type TypeNumberInputCellProps = TypeNumberInputCellParams & {
  value?: string | null;
};

/**
 * 숫자만 입력가능한 Number Input 셀 렌더러
 */
const NumberInputCell = ({
  value,
  placeholder = '입력',
  disabled,
  maxLength,
  status,
  validationMessage,
  onChange,
  onBlur,
  onFocus,
}: TypeNumberInputCellProps) => {
  const [currentValue, setCurrentValue] = useState(value ?? '');

  useEffect(() => {
    setCurrentValue(value ?? '');
  }, [value]);

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentValue(e.target.value);
    onChange?.(e.target.value);
  };

  const handleBlurInput = () => {
    onBlur?.(currentValue);
  };

  const handleFocusInput = () => {
    onFocus?.();
  };

  return (
    <div className={styles['cell-wrapper']}>
      <NumberUnitInput
        size="tiny"
        value={currentValue}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        status={status}
        validationMessage={validationMessage}
        onChange={handleChangeInput}
        onBlur={handleBlurInput}
        onFocus={handleFocusInput}
      />
    </div>
  );
};

export default NumberInputCell;
